<template>
    <img
        :alt="alt"
        :title="title"
        :class="{
            'deferred-img': true,
            'deferred-img--loading': isLoading,
        }"
        :src="fakeImg"
    >
</template>

<script>
import { on, off } from '@v4/common/utils/dom';
import { fakeImg } from '@v4/common/utils';

export default {
    name: 'DeferredImg',
    props: {
        src: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '',
        },
        alt: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            isLoading: true,
            fakeImg,
        };
    },
    mounted() {
        if (this.src) {
            if (document.readyState === 'complete') {
                this.deferImage();
            } else {
                on(window, 'load', this.deferImage);
            }
        }
    },
    destroyed() {
        if (this.src) {
            off(window, 'load', this.deferImage);
        }
    },
    methods: {
        deferImage() {
            this.$el.setAttribute('src', this.src);
            this.isLoading = false;
        },
    },
};
</script>
